exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.facture-libelle .el-form-item__label::before {\n  content: \"* \";\n  color: #F56C6C;\n}\n", ""]);

// exports
